import { Inject, Injectable } from "@angular/core";
import { FormArray, FormControlStatus, FormGroup } from "@angular/forms";
import {
  BaseFpxComponentState,
  BaseFpxFormHelper,
  HttpProviderService,
  IHttpSuccessPayload,
  RoutingInfo,
  BaseFpxChangeHandler,
  BaseFpxControlEventHandler,
  HttpRequest,
  SpinnerService,
  CriteriaQuery,
} from "@fpx/core";
import { BehaviorSubject, map } from "rxjs";
import { BeneficiariesService } from '../beneficiaries-service/beneficiaries.service';
import { Beneficiaries } from '../beneficiaries-service/beneficiaries.model';
import { BeneListDisplayGridHelper } from "../bene-list-display-grid/bene-list-display-grid.helper";
import { BeneficiaryMainService } from "../services/beneficiary-main.service";
import { Router } from "@angular/router";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { BeneficiariesListDisplayGridHelper } from "../beneficiaries-list-display-grid/beneficiaries-list-display-grid.helper";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";



export class ManageBeneFormState extends BaseFpxComponentState {
 	showSuggestion : boolean = false;
   refreshCriteria$: BehaviorSubject<CriteriaQuery> = new BehaviorSubject<CriteriaQuery>(null);

}


@Injectable()
export class ManageBeneFormHelper extends BaseFpxFormHelper<ManageBeneFormState>{
  cardData: any;

   constructor(public processShell: ProcessShellService,public beneficiaryMainService: BeneficiaryMainService,
     private manageBeneFormService: BeneficiariesService,
         @Inject(MAT_DIALOG_DATA) public data: any,
     private _router:Router)
    {
        super(new ManageBeneFormState());
    }

  override doPreInit(): void {
    this.addChangeHandler("beneFilterRadio", this.doBeneFilterRadioChange);
    this.cardData = this.data.screenData.data;
  }

  public override doPostInit(): void {
    this.formGroup.get('beneFilterRadio').patchValue('ALL', { emitEvent: false });
    const criteriaQuery = new CriteriaQuery();
    this.state.refreshCriteria$.next(criteriaQuery);
  }
  addBene(){
    this._router.navigate(['process-shell', 'transfers', 'add-bene-home-form'], {
      queryParams: {
        "processCode": "ADDBENIFICIARY",
        "ProcessTitle": "ADD BENEFICIARY",
        "additionalDetails": {
          "backNav": ['home', 'transfers']
        }
      },
      queryParamsHandling: "preserve"
    });
  }

  private doBeneFilterRadioChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
  ) => {
    // WRITE CODE HERE TO HANDLE
    const criteriaQuery = new CriteriaQuery();
    if(value=='ALL' && this.cardData != undefined && this.cardData == 'TRANDOMESTIC') {
criteriaQuery.addFilterCritertia(
        'serviceCode',
        'String',
        'equals',
        {
          searchText: 'BENEDOMESTIC',
        });
        this.beneficiaryMainService.currentServiceCode = 'BENEDOMESTIC';
} else if (value=='ALL' && this.cardData != undefined && this.cardData == 'TRANINTERNATIONAL') {
criteriaQuery.addFilterCritertia(
        'serviceCode',
        'String',
        'equals',
        {
          searchText: 'BENEINTERNATIONAL',
        });
        this.beneficiaryMainService.currentServiceCode = 'BENEINTERNATIONAL';
} else if(value=='ALL'){
      this.beneficiaryMainService.currentServiceCode = 'ALL';
    }else if(value == 'FAV'){
      criteriaQuery.addFilterCritertia(
        'isFavourite',
        'String',
        'equals',
        {
          searchText: '1',
        });
        this.beneficiaryMainService.currentServiceCode = 'FAV';
    }
    else if(value == 'BENEINTBT'){
      criteriaQuery.addFilterCritertia(
        'serviceCode',
        'String',
        'equals',
        {
          searchText: 'BENEINTBT',
        });
        this.beneficiaryMainService.currentServiceCode = 'BENEINTBT';
    }
    else if(value == 'BENESWIFT'){
      criteriaQuery.addFilterCritertia(
        'serviceCode',
        'String',
        'equals',
        {
          searchText: 'BENESWIFT',
        });
        this.beneficiaryMainService.currentServiceCode = 'BENESWIFT';
    }
    else if(value == 'BENEINTRAC'){
      criteriaQuery.addFilterCritertia(
        'serviceCode',
        'String',
        'equals',
        {
          searchText: 'BENEINTRAC',
        });
        this.beneficiaryMainService.currentServiceCode = 'BENEINTRAC';
    }
    else if(value == 'BENEIFSC'){
      criteriaQuery.addFilterCritertia(
        'serviceCode',
        'String',
        'equals',
        {
          searchText: 'BENEIFSC',
        });
        // criteriaQuery.addQueryparam()
        this.beneficiaryMainService.currentServiceCode = 'BENEIFSC';
    }
    else if(value == 'BENEDOMESTIC'){
      criteriaQuery.addFilterCritertia(
        'serviceCode',
        'String',
        'equals',
        {
          searchText: 'BENEDOMESTIC',
        });
        this.beneficiaryMainService.currentServiceCode = 'BENEDOMESTIC';
        // criteriaQuery.addQueryparam()
    }  else if(value == 'BENEINTERNATIONAL'){
      criteriaQuery.addFilterCritertia(
        'serviceCode',
        'String',
        'equals',
        {
          searchText: 'BENEINTERNATIONAL',
        });
        this.beneficiaryMainService.currentServiceCode = 'BENEINTERNATIONAL';
        // criteriaQuery.addQueryparam()
    }
    criteriaQuery.addQueryparam('serviceCode',value);
    
    this.state.refreshCriteria$.next(criteriaQuery);


  };



  public override preSubmitInterceptor(payload: Beneficiaries):any {
     // WRITE CODE HERE TO HANDLE
    return payload;
  }

  public override postSubmitInterceptor(response:any): RoutingInfo {
    console.log(response);
    let routingInfo: RoutingInfo = new RoutingInfo();
    // routingInfo.setNavigationURL("confirmation");
    if (response.success) {
      routingInfo.setQueryParams({
        transRef: response.success?.body?.fpxdeposit?.depositRef,
        status: "success",
      });
    } else if (response.error) {
      routingInfo.setQueryParams({ status: "failed" });
    }
    return routingInfo;
  }
 //$START_CUSTOMSCRIPT\n
 //$END_CUSTOMSCRIPT\n
}
